<template lang="pug">
  BTooltip.wt-tooltip(
    :active="active"
    :label="text"
    type="is-dark"
    :multilined="position === 'is-top'"
    animated
    :position="position"
  )
    BIcon(icon="information" type="is-grey")
</template>

<script>
export default {
  name: "WtTooltip",

  props: {
    text: {
      type: String,
      required: true
    },

    position: {
      type: String,
      default: "is-top"
    },

    active: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="sass" scoped>
.wt-tooltip
  margin-left: .4rem
</style>
